import { FiFileText, FiList, FiMessageSquare } from 'react-icons/fi';
import { PERMISSIONS } from '_constants';

/**
 * The visit view's sections, previously a tab strip above the content.
 *
 * Two are gated: `Audit logs` by the audit-log role permission, `Notes` by the `retailer_notes`
 * account module (P20M-1242 R14 — no extra role permission: every note there is derived from visit
 * fields the viewer already sees in the form on this page). When only one section survives the gates
 * the sidebar is skipped entirely — the details simply fill the page, exactly as the tab strip was
 * already hidden in that case.
 */
export const SECTION_GROUPS = [
  {
    key: 'visit',
    label: 'Visit',
    items: [
      { key: 'Visit details', label: 'Visit details', icon: FiFileText },
      { key: 'Notes', label: 'Notes', icon: FiMessageSquare, module: PERMISSIONS.RETAILER_NOTES },
      { key: 'Audit logs', label: 'Audit logs', icon: FiList, permission: PERMISSIONS.VIEW_AUDIT_LOG },
    ],
  },
];

export const DEFAULT_SECTION = 'Visit details';

// Every section key: the whitelist for `?activeTab=` (useUrlParamState), so a stale or hand-edited link
// falls back to the default instead of an unknown section.
export const ALL_SECTION_KEYS = SECTION_GROUPS.flatMap((g) => g.items.map((i) => i.key));

export const findSectionMeta = (sectionKey) =>
  SECTION_GROUPS.flatMap((g) => g.items).find((item) => item.key === sectionKey) || null;
